import {
  booleanFeatureFlags,
  defineFamaFlagDefinitions,
  normalizeBehaviorMapping,
  type BehaviorMappingActions,
} from "./FeatureFlagDefinition";

export const FAMA_FLAG_DEFINITIONS = defineFamaFlagDefinitions({
  ...booleanFeatureFlags(true, {
    showBehaviorKit: "V3_BEHAVIOR_KITS",
    showReportsClient: "V3_REPORTS_CLIENT",
    showResumeParse: "V3_ENABLE_RESUME_PARSE",
    enableNextTaskRedirect: "V3_USE_NEXT_TASK",
    enableProductReportsForClientTab: "V3_CLIENT_VIEW_PRODUCT_REPORTS",
    hasTasksOnlyQueue: "V3_WITH_HAS_TASKS_ONLY_QUEUE",
    useReportWizard: "V3_USE_REPORT_WIZARD_UI",
    hybridReportRerun: "HYBRID_REPORT_RERUN",
  }),
  ...booleanFeatureFlags(false, {
    showVersionNumber: "SHOW_VERSION_NUMBER",
    enableAddPersonMulticheckType: "V3_ADD_PERSON_MULTICHECK",
    enableIqaRowFetch: "IQA_ROWS_ENDPOINT_ENABLED",
    useStatsInSummary: "V3_UI_USE_STATS_IN_SUMMARY",
    v3UiBulkUpload2025: "V3_UI_BULK_UPLOAD_2025",
    v3UiCompletedListWith360: "V3_UI_COMPLETED_LIST_WITH_360",
    v3UiReportSummaryInsightRedesign: "V3_UI_REPORT_SUMMARY_INSIGHT_REDESIGN",
    v3Ui360ListViewsV2026: "V3-UI-360-LIST-VIEWS-V2026",
    v3UiMisconductListsV2026: "V3-UI-MISCONDUCT-LISTS-V2026",
    v3UiInProcessActiveSteps: "V3-UI-IN-PROCESS-ACTIVE-STEPS",
    v3DiligenceEnabled: "V3_DILIGENCE_ENABLED",
    v3EuResidenceShowToggle: "V3_EU_RESIDENCE_SHOW_TOGGLE",
    v3EuBadgeEnabled: "V3_UI_EU_BADGE_ENABLED",
    v3UiReactsToWebsocketWorkflowEvents:
      "V3-UI-REACTS-TO-WEBSOCKET-WORKFLOW-EVENTS",
    enableProfiler: "ENABLE_PROFILER",
  }),
  behaviorMappingActions: {
    ldKey: "V3_BEHAVIORS_MAPPING_ACTIONS",
    default: {
      hide: [],
      mapper: {},
      show: [],
      showAll: false,
      useMapper: false,
    } as BehaviorMappingActions,
    normalize: normalizeBehaviorMapping,
  },
});
